export default {
  tabs: {
    accounts: "Cuentas",
    report_config: "Configuración de informes",
    general: "General",
    billing_notifications: "Facturación y notificaciones",
    privacy: "Privacidad",
    help: "Ayuda",
    about: "Acerca de",
  },
  general: {
    title: "Configuración general",
    displaySettings: "Configuración de visualización",
    theme: "Tema",
    primaryColor: "Color primario",
    languageSettings: "Configuración de idioma",
    language: "Idioma",
    otherSettings: "Otras configuraciones",
    timezone: "Zona horaria",
    selectTimezone: "Seleccionar zona horaria",
    dateFormat: "Formato de fecha",
    selectDateFormat: "Seleccionar formato de fecha",
    numberFormat: "Formato numérico",
    selectNumberFormat: "Seleccionar formato numérico",
    englishFormat: "Formato inglés",
    europeanFormat: "Formato europeo",
    spaceFormat: "Formato con espacios",
  },
  account: {
    title: "Configuración de cuenta",
    subtitle:
      "Gestione su información personal, configuraciones de seguridad y preferencias de cuenta",
    edit: "Editar",
    save: "Guardar cambios",
    cancel: "Cancelar",
    profile: {
      title: "Información personal",
      name: "Nombre",
      email: "Dirección de correo electrónico",
      email_tip: "La dirección de correo electrónico no se puede cambiar",
      company: "Empresa",
      phone: "Teléfono",
      phone_invalid: "El formato del número de teléfono es inválido",
      bio: "Biografía",
      website: "Sitio web",
      website_invalid: "El formato de URL del sitio web es inválido",
      location: "Ubicación",
      position: "Cargo",
      validation_error: "Error en la validación del formulario, por favor verifique sus entradas",
      change_avatar: "Cambiar avatar",
      remove: "Eliminar avatar",
      save_success: "Perfil actualizado con éxito",
      avatar_format_error: "¡Solo puede cargar archivos JPG/PNG!",
      avatar_size_error: "¡La imagen debe ser menor a 2 MB!",
      avatar_upload_error: "Error al cargar el avatar",
      avatar_format_tip: "Formato JPG/PNG",
      avatar_size_tip: "Tamaño máximo de archivo: 2 MB",
      name_placeholder: "Ingrese su nombre",
      company_placeholder: "Ingrese su empresa",
      phone_placeholder: "Ingrese su número de teléfono",
      bio_placeholder: "Cuéntenos sobre usted",
      website_placeholder: "https://ejemplo.com",
      location_placeholder: "Ingrese su ubicación",
      position_placeholder: "Ingrese su cargo",
    },
    security: {
      password_title: "Configuración de contraseña",
      password_tip:
        "Para la seguridad de su cuenta, se recomienda cambiar su contraseña regularmente",
      change_password: "Cambiar contraseña",
      current_password: "Contraseña actual",
      new_password: "Nueva contraseña",
      confirm_password: "Confirmar nueva contraseña",
      save_password: "Guardar contraseña",
      password_changed: "Contraseña actualizada",
      password_mismatch: "La nueva contraseña y la confirmación no coinciden",
      password_incorrect: "La contraseña actual es incorrecta",
      password_required: "Por favor complete todos los campos de contraseña",
      password_too_short: "La contraseña debe tener al menos 8 caracteres",
      password_change_failed: "Error al cambiar la contraseña",
      two_factor_auth_title: "Autenticación de dos factores",
      two_factor_auth: "Autenticación de dos factores",
      two_factor_auth_desc:
        "Agregue una capa adicional de seguridad que requiera tanto su contraseña como un código de verificación del dispositivo para iniciar sesión",
      two_factor_auth_coming_soon: "Próximamente",
      // Agregar textos de marcador de posición
      current_password_placeholder: "Ingrese la contraseña actual",
      new_password_placeholder: "Ingrese la nueva contraseña",
      confirm_password_placeholder: "Confirme la nueva contraseña",
    },
    login_activity: {
      title: "Actividad de inicio de sesión",
      manage: "Gestionar",
      trust_device: "Confiar en dispositivo",
      logout_device: "Cerrar sesión en dispositivo",
      device_trusted: "Dispositivo {location} aprobado",
      device_logged_out: "Sesión cerrada en dispositivo {location}",
      showing_details: "Mostrando detalles para {location} - IP: {ip}, Hora: {time}",
      manage_info: "Gestionando actividad de inicio de sesión para {location}",
      login_details: "Detalles de inicio de sesión",
      ip_address: "Dirección IP",
      time: "Hora",
      isp: "Proveedor de servicios de Internet",
      bot_score: "Puntaje de bot",
      locations: {
        current: "Dispositivo actual",
      },
      suspicious: "Sospechoso",
      mobile_device: "Dispositivo móvil",
      api_client: "Cliente API",
      trusted: "Confiado",
      device: "Dispositivo",
      client: "Cliente",
      unknown: "Desconocido",
      risk_reasons: "Razones de riesgo",
      location: "Ubicación",
      trust_failed: "Error al aprobar dispositivo",
      show_more: "Mostrar {0} más",
      show_less: "Mostrar menos",
    },
    danger: {
      title: "Zona peligrosa",
      delete_title: "Eliminar cuenta",
      delete_desc:
        "Elimine permanentemente su cuenta y todos los datos asociados. Esta acción no se puede deshacer.",
      confirm_title: "¿Está seguro de que desea eliminar su cuenta?",
      confirm_desc:
        "Esta acción eliminará permanentemente su cuenta y todos los datos asociados. No se puede deshacer.",
      confirm_email_tip:
        "Para confirmar la eliminación, por favor ingrese su dirección de correo electrónico:",
      confirm_email_placeholder: "Ingrese su dirección de correo electrónico",
      confirm: "Confirmar eliminación",
      cancel: "Cancelar",
      delete_account: "Eliminar cuenta",
      delete_success: "Cuenta eliminada con éxito",
      email_mismatch:
        "La dirección de correo electrónico no coincide. Por favor ingrese la dirección correcta.",
    },
  },
  privacy: {
    title: "Configuración de privacidad",
    privacyPolicyAgreement: "Acuerdo de política de privacidad",
    privacyPolicyAgreementDesc:
      "Ha aceptado nuestra Política de Privacidad al registrarse para una cuenta",
    privacyPolicyAgreementInfo: "El acuerdo de política de privacidad no se puede revocar",
  },
  reportConfig: {
    colorPicker: {
      title: "Selector de color",
    },
    currencyName: {
      EUR: "Euro (€)",
      USD: "Dólar estadounidense ($)",
      GBP: "Libra esterlina (£)",
    },
    fetchDataFailed: "Error al obtener datos",
    configSelection: "Selección de configuración",
    default: "Predeterminado",
    professional: "Profesional",
    simple: "Simple",
    custom: "Personalizado",
    exportType: "Tipo de exportación",
    upgradeToUnlock: "Actualice para desbloquear esta función",
    commonSettings: "Configuraciones comunes",
    tableHeaderFont: "Fuente del encabezado de tabla",
    tableCellFont: "Fuente de celdas de tabla",
    textFont: "Fuente del texto",
    textColor: "Color del texto",
    tableHeaderBg: "Fondo del encabezado de tabla",
    selectColor: "Seleccionar color",
    dataFormat: "Formato de datos",
    selectFormat: "Seleccionar formato",
    titleFontSize: "Tamaño de fuente del título",
    watermarkFontSize: "Tamaño de fuente de marca de agua",
    titleColor: "Color del título",
    premiumTitleColorActive: "Color de título premium activo",
    blue: "Azul",
    red: "Rojo",
    displayFields: "Campos a mostrar",
    showDate: "Mostrar fecha",
    showContact: "Mostrar contacto",
    showEmail: "Mostrar correo electrónico",
    showTitle: "Mostrar título",
    showEmissionDetails: "Mostrar detalles de emisiones",
    showSummary: "Mostrar resumen",
    showTotalDistance: "Mostrar distancia total",
    showProductionEmission: "Mostrar emisión de producción",
    showTransportEmission: "Mostrar emisión de transporte",
    showTotalEmission: "Mostrar emisión total",
    showTax: "Mostrar impuesto",
    showCompliance: "Mostrar declaración de cumplimiento",
    privacyFields: "Campos de privacidad",
    hideCompanyName: "Ocultar nombre de empresa",
    hideContact: "Ocultar contacto",
    hideEmail: "Ocultar correo electrónico",
    hideLogo: "Ocultar logotipo de empresa",
    hideWeight: "Ocultar peso",
    premiumFeatures: "Funciones premium",
    generalConfig: "Configuración general",
    language: "Idioma",
    selectLanguage: "Seleccionar idioma",
    currency: "Moneda",
    selectCurrency: "Seleccionar unidad de moneda",
    showLogo: "Mostrar logotipo",
    companyLogo: "Logotipo de empresa",
    logoSupportFormat: "Formatos admitidos: JPG, PNG, GIF, WEBP, Máx. 2 MB",
    showCompany: "Mostrar empresa",
    companyName: "Nombre de empresa",
    enterCompanyName: "Ingrese el nombre de la empresa",
    customContact: "Contacto personalizado",
    enterContact: "Ingrese el contacto",
    customEmail: "Correo electrónico personalizado",
    enterEmail: "Ingrese el correo electrónico",
    customCompliance: "Declaración de cumplimiento personalizada",
    enterCompliance: "Ingrese la declaración de cumplimiento",
    customFooter: "Pie de página personalizado",
    excelFontStyle:
      "El estilo de fuente en Excel está controlado por la configuración predeterminada",
    footerPlaceholder: "ej. Informe de cumplimiento CBAM TaxEcoBit",
    showEmissionChart: "Mostrar gráfico de emisiones",
    pdfAdvancedFeatures: "Funciones avanzadas de PDF",
    removeWatermark: "Eliminar marca de agua",
    showSignatureArea: "Mostrar área de firma",
    removeQRCode: "Eliminar código QR",
    logoPosition: "Posición del logotipo",
    selectPosition: "Seleccionar posición",
    topLeft: "Superior izquierda",
    topRight: "Superior derecha",
    borderStyle: "Estilo de borde",
    none: "Ninguno",
    solid: "Sólido",
    premiumTitleColor: "Color de título premium",
    customTableHeaderBg: "Fondo de encabezado de tabla personalizado",
    customWatermark: "Marca de agua personalizada",
    enterWatermark: "Ingrese el contenido de la marca de agua",
    inviteText: "Texto de invitación",
    enterInviteText: "Ingrese el texto de invitación",
    excelAdvancedFeatures: "Funciones avanzadas de Excel",
    columnWidth: "Ancho de columna",
    cellBackground: "Fondo de celda",
    mergeHeader: "Fusionar encabezado",
    enableFilter: "Habilitar filtro",
    addDigitalSignature: "Agregar firma digital",
    signatureContent: "Contenido de firma",
    enterSignature: "Ingrese el contenido de la firma",
    premiumFeaturesDesc:
      "Estas funciones premium pueden mejorar la profesionalidad de sus informes",
    upgradeMessage:
      "Actualice a premium para desbloquear el cambio de idioma, logotipo personalizado y otras funciones exclusivas",
    lightGray: "Gris claro",
    darkGray: "Gris oscuro",
    messages: {
      excelExportRequiresPro:
        "La exportación de Excel requiere una suscripción Pro, cambiado a PDF",
      logoUploadFailed: "Error al cargar el logotipo",
      configSaveSuccess: "Configuración guardada con éxito",
      configSaveFailed: "Error al guardar la configuración",
      imageFileOnly: "¡Solo se admiten archivos de imagen!",
      imageSizeLimit: "¡El tamaño de la imagen no debe exceder 2 MB!",
      fileReadFailed: "Error al leer el archivo",
    },
  },
  billing: {
    title: "Facturación y notificaciones",
    compliance: "Cumplimiento requerido",
    compliance_desc: "Notificaciones críticas, no se pueden desactivar",
    service: "Servicio crítico",
    service_desc: "Recomendado mantener activo",
    experience: "Experiencia de usuario",
    experience_desc: "Opcional, se puede desactivar",
  },
  notification: {
    title: "Configuración de notificaciones",
    policy: "Actualizaciones de política CBAM",
    policy_desc:
      "Reciba cambios urgentes en la regulación de la CBAM de la UE. Requerido para cumplimiento y evitar penalidades.",
    payment: "Alertas de fallo de pago",
    payment_desc:
      "Sea notificado inmediatamente si el pago falla para evitar interrupción del servicio.",
    expiry: "Recordatorios de vencimiento del plan",
    expiry_desc:
      "Sea notificado 3 días antes del vencimiento de su plan. Renueve a tiempo para evitar la pausa del servicio.",
    quota: "Advertencias de cuota",
    quota_desc: "Alerta cuando use el 80% de los cálculos mensuales. Evite límites inesperados.",
    ticket: "Actualizaciones de tickets de soporte",
    ticket_desc:
      "Reciba actualizaciones por correo electrónico cuando cambie el estado de su ticket de soporte.",
    referral: "Recompensas de referidos",
    referral_desc: "Sea notificado cuando gane cálculos gratuitos a través de referidos exitosos。",
  },
  info: {
    about_taxecobit: "Acerca de TaxEcoBit",
    about_taxecobit_description:
      "TaxEcoBit es una herramienta especializada diseñada para PYME de la UE para racionalizar los informes y el cumplimiento de emisiones de carbono de la CBAM. Con una precisión superior al 90%, permite cálculos y generación de informes rápidos, ayudando a mitigar el riesgo de penalidades (1,000 € a 10,000 €).",
    our_vision: "Nuestra visión",
    our_vision_description:
      "Buscamos empoderar a las PYME de la UE con un cumplimiento de la CBAM transparente, fomentando el crecimiento sostenible y apoyando los objetivos de sostenibilidad de 2026 a través de soluciones innovadoras.",
    contact_us: "Contáctenos",
    follow_us: "Síganos:",
    version_info: "Información de versión",
    version: "Versión",
    last_updated: "Última actualización",
    license: "Licencia",
    copyright: "© 2025 TaxEcoBit. Todos los derechos reservados.",
  },
};
